<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="point-terms-of-service">
      <Title jpn="Términos de uso de monedas" />
      <div class="scroll-container">
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Estos Términos de uso (en lo sucesivo, "Términos de uso de Coin") establecen las condiciones para usar "Coin" (definido a continuación) en
              <a href="https://dorima-gtchax.com/" target="_blank" >https://dorima-gtchax.com/</a>
              (en lo sucesivo, el "Servicio") proporcionado por Hatchi Co., Ltd. (en lo sucesivo, la "Compañía").</span>
            <span class="text">Lea atentamente los Términos de uso de Coin antes de considerar comprar Coin.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Artículo 1 - Definición de términos</span>
            <span class="text">El significado de los términos de los siguientes puntos de estos Términos será el especificado en cada punto.</span>
            <span class="text">(1) “Acuerdo de Uso del Servicio” significa un contrato relacionado con el uso del Servicio.</span>
            <span class="text">(2) "Usuario del servicio" significa una persona que ha celebrado un contrato de uso del servicio con nuestra empresa.</span>
            <span class="text">(3) "Información de cuenta" significa información relacionada con el Usuario del Servicio que el Usuario del Servicio ha registrado en el Servicio.</span>
            <span class="text">(4) "Moneda" significa una moneda que solo puede ser utilizada por nuestra empresa.</span>
            <span class="text">(5) "Saldo utilizado" es el saldo de Monedas retenidas y disponibles para su uso por parte del usuario del servicio.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Artículo 2 - Moneda</span>
            <span class="text">(1) Los usuarios del Servicio pueden comprar Monedas que se pueden usar dentro del Servicio utilizando el método especificado por la Compañía y al precio indicado por la Compañía dentro del Servicio. Además, la Compañía puede establecer unidades de compra, métodos de pago, períodos de uso y otras condiciones de compra para la compra de Monedas para los usuarios del servicio, y las condiciones de compra establecidas y el monto a pagar, etc. se publicarán dentro del Servicio o los servicios operados por la Compañía.</span>
            <span class="text">(2) Cuando un usuario del servicio expresa su intención de comprar una Moneda utilizando el método prescrito por la Compañía, se establecerá un contrato entre el Usuario del Servicio y la Compañía con respecto a la compra de la Moneda y se determinará el monto total de la compra.</span>
            <span class="text">(3) Si el usuario del servicio que compra Coin es menor de edad, el usuario del servicio debe obtener el consentimiento de un padre o tutor antes de comprar Coin.</span>
            <span class="text">(4) Si un menor compra una Moneda, la Compañía asumirá que la persona con patria potestad ha dado su consentimiento para la compra de la Moneda.</span>
            <span class="text">(5) El saldo de uso del usuario del servicio que se muestra dentro del Servicio se vinculará a la información de la cuenta y se registrará en el equipo de telecomunicaciones utilizado para proporcionar el Servicio y otros servicios operados por la Compañía.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Artículo 3 - Uso de la moneda</span>
            <span class="text">(1) Se pueden utilizar monedas para comprar nuestros productos.</span>
            <span class="text">(2) Los usuarios del servicio pueden adquirir productos proporcionados por la Compañía dentro del monto de su saldo de Monedas.</span>
            <span class="text">(3) Si un usuario del servicio utiliza Coin para comprar un producto de la Compañía, el precio del producto se deducirá del saldo de Coin y se considerará que el monto ha sido pagado.</span>
            <span class="text">A menos que se especifique lo contrario, las Monedas otorgadas de forma gratuita por la Compañía a los usuarios del Servicio se consumirán preferentemente.</span>
            <span class="text">(4) Los usuarios del Servicio pueden consultar su saldo de Monedas dentro del Servicio. Además, los usuarios del servicio son responsables de gestionar y comprobar el aumento y disminución de Coins.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Artículo 4 - Manejo de monedas</span>
            <span class="text">(1) La Compañía otorgará Monedas al Usuario de acuerdo con el método determinado por la Compañía cuando el Usuario compre Monedas en el Servicio, cuando la Compañía realice una campaña o en otros casos. La Compañía determinará la unidad de compra de Monedas, el precio, el período de validez y otras condiciones para otorgar Monedas y se mostrarán en el Servicio.</span>
            <span class="text">(2) El período de validez de la Moneda es de 6 meses a partir de la fecha de concesión de la Moneda.</span>
            <span class="text">(3) La Compañía no reembolsará ninguna Moneda adquirida por el Usuario, a menos que lo exija la ley. En el caso de reembolsar Monedas según las leyes y regulaciones, el método y las condiciones de reembolso se publicarán por separado de la manera que determine la Compañía.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Artículo 5 - Prohibición de conversión de efectivo, etc.</span>
            <span class="text">Con respecto a todo el contenido adquirido dentro de este servicio, está prohibida cualquier transferencia, transferencia, préstamo, préstamo, etc. en forma de dar o recibir dinero u otra contraprestación del mundo real (incluido, entre otros, el llamado RMT [comercio con dinero real]), ya sea directamente, a través de la intermediación de terceros, subasta por Internet u otros medios.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Artículo 6 - Transferencia de monedas, etc.</span>
            <span class="text">Los usuarios del servicio no pueden ceder, prestar, regalar ni transferir de otro modo monedas o productos a un tercero, ni pueden pignorar ni establecer de otro modo una garantía real.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Artículo 7 - Suspensión de la compra y uso de Monedas, etc.</span>
            <span class="text">Si un Usuario del Servicio se encuentra en cualquiera de los siguientes casos, la Compañía puede tomar medidas contra el Usuario del Servicio que la Compañía considere apropiadas (incluidas, entre otras, la suspensión de la compra o el uso de Coin).</span>
            <span class="text">(1) Si las monedas o productos se obtienen o utilizan por medios ilegales</span>
            <span class="text">(2) Si el usuario del servicio viola estos Términos de uso</span>
            <span class="text">(3) En otros casos en los que la Compañía determine que el uso del Servicio por parte del Usuario del Servicio es inapropiado.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Establecido el 28 de febrero de 2025</span>
          </div>
        </ShadowBoxTitleDescription>
      </div>
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import ShadowBoxTitleDescription from '@/components/molecules/ShadowBoxTitleDescription.vue';
import Title from '@/components/molecules/Title02.vue';
import t from '@/plugins/i18n_point_terms_of_service';

export default {
  name: 'TermsOfService',
  mixins: [t],

  components: {
    BaseTemplate,
    ShadowBoxTitleDescription,
    Title,
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
    }),
  },

  created() {
    this.$store.dispatch('user/setCurrentUser', { token: 'yugi' });
  },
};
</script>

<style lang="scss" scoped>
.point-terms-of-service{
  width: 100%;
  max-width: 1000px;
  min-height: 100%;
  padding: 30px 20px 0px;
  margin: 0px auto;
  .point-terms-of-service-title{
    display: flex;
    justify-content: center;
    .text{
      height: 35px;
      font-family: $notoSerif;
      font-size: 24px;
      font-weight: 700;
    }
  }
  .scroll-container{
    width: 100%;
    margin-top: 30px;
    padding-bottom: 50px;
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
    .shadow-box-title-description{
      width: 100%;
      .text-container{
        display: flex;
        flex-direction: column;
        padding: 5px 5px 0px 5px;
        .text{
          font-family: $notoSans;
          font-size: 13px;
          line-height: 1.5;
          letter-spacing: 0.03em;
          a {
            color: black!important;
          }
          &.margin-top{
            margin-top: 10px;
          }
          &.one-line-space-top{
            margin-top: 1em;
          }
        }
      }
      & + .shadow-box-title-description{
        margin-top: 40px;
      }
    }
  }
}
</style>
